"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var defaults = {
  start: null,
  end: null
};

function convertToMinutes(timestamp) {
  return Math.floor(timestamp / 60000);
}

function convertToMilliseconds(timestamp) {
  return timestamp * 60000;
}

var TimeRange = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(TimeRange, _Record);

  function TimeRange() {
    (0, _classCallCheck2.default)(this, TimeRange);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimeRange).apply(this, arguments));
  }

  (0, _createClass2.default)(TimeRange, [{
    key: "toBlocks",
    value: function toBlocks(duration
    /* number */
    ) {
      var _this = this;

      return (0, _immutable.Range)(0, Math.floor(this.duration() / duration)).map(function (i) {
        return TimeRange.from({
          start: _this.start + i * duration,
          end: _this.start + (i + 1) * duration
        });
      });
    }
  }, {
    key: "toMinutes",
    value: function toMinutes() {
      if (!this.isInMinutes()) {
        return TimeRange.from({
          start: convertToMinutes(this.start),
          end: convertToMinutes(this.end)
        });
      }

      return this;
    }
  }, {
    key: "toMilliseconds",
    value: function toMilliseconds() {
      if (!this.isInMilliseconds()) {
        return TimeRange.from({
          start: convertToMilliseconds(this.start),
          end: convertToMilliseconds(this.end)
        });
      }

      return this;
    }
  }, {
    key: "isInMilliseconds",
    value: function isInMilliseconds() {
      var FIFTEEN_MINUTE_DURATION = _I18n.default.moment.duration({
        minutes: 15
      }).asMilliseconds();

      return Math.floor(this.end / FIFTEEN_MINUTE_DURATION) >= 1;
    }
  }, {
    key: "isInMinutes",
    value: function isInMinutes() {
      var DAY_DURATION_MINUTES = _I18n.default.moment.duration({
        hours: 24
      }).asMinutes();

      return Math.floor(this.end / DAY_DURATION_MINUTES) <= 1;
    }
  }, {
    key: "isValidTimeRange",
    value: function isValidTimeRange() {
      return (0, _immutable.List)([typeof this.start, typeof this.end]).every(function (t) {
        return t === 'number';
      });
    }
  }, {
    key: "duration",
    value: function duration() {
      return this.end - this.start;
    }
  }, {
    key: "contain",
    value: function contain(time
    /* Time */
    ) {
      return Math.max(Math.min(time, this.end - 1), this.start);
    }
  }, {
    key: "timeToOffsetFloat",
    value: function timeToOffsetFloat(time
    /* Time */
    ) {
      return (time - this.start) / this.duration();
    }
  }, {
    key: "isEqual",
    value: function isEqual(dtr
    /* TimeRange */
    ) {
      return this.start === dtr.start && this.end === dtr.end;
    }
  }, {
    key: "hasIntersection",
    value: function hasIntersection(dtr
    /* TimeRange */
    ) {
      return this.start < dtr.end && this.end > dtr.start;
    }
  }, {
    key: "contains",
    value: function contains(time
    /* Time */
    ) {
      return this.start <= time && this.end > time;
    }
  }, {
    key: "pushBack",
    value: function pushBack(duration
    /* number */
    ) {
      return TimeRange.from({
        start: this.start - duration,
        end: this.end - duration
      });
    }
  }, {
    key: "subtractStart",
    value: function subtractStart(duration
    /* number */
    ) {
      return TimeRange.from({
        start: this.start - duration,
        end: this.end
      });
    }
  }, {
    key: "subtractEnd",
    value: function subtractEnd(duration
    /* number */
    ) {
      return TimeRange.from({
        start: this.start,
        end: this.end - duration
      });
    }
  }, {
    key: "union",
    value: function union(dtr
    /* TimeRange */
    ) {
      if (!this.hasIntersection(dtr)) return (0, _immutable.List)([this, dtr]);
      return (0, _immutable.List)([TimeRange.from({
        start: Math.min(this.start, dtr.start),
        end: Math.max(this.end, dtr.end)
      })]);
    }
  }, {
    key: "intersect",
    value: function intersect(dtr
    /* TimeRange */
    ) {
      if (!this.hasIntersection(dtr)) return null;
      return TimeRange.from({
        start: Math.max(this.start, dtr.start),
        end: Math.min(this.end, dtr.end)
      });
    }
  }, {
    key: "clipEnd",
    value: function clipEnd(edge
    /* Time */
    ) {
      if (edge < this.start) return null;
      return TimeRange.from({
        start: Math.min(edge, this.start),
        end: Math.min(edge, this.end)
      });
    }
  }, {
    key: "clipStart",
    value: function clipStart(edge
    /* Time */
    ) {
      if (edge > this.end) return null;
      return TimeRange.from({
        start: Math.max(edge, this.start),
        end: Math.max(edge, this.end)
      });
    }
  }], [{
    key: "from",
    value: function from(json) {
      return new TimeRange(json);
    }
  }]);
  return TimeRange;
}((0, _immutable.Record)(defaults));

exports.default = TimeRange;
module.exports = exports.default;